import LogRocket from 'logrocket'

const id = Math.floor(Math.random() * 1000000) + 1

/**
 * Initializes the module
 */
const initQuoteFormTracking = () => {
  const emailField = document.querySelector('[name="Form.EmailAddress"]')
  if (emailField) {
    emailField.addEventListener('blur', onEmailFieldBlur)
  }
}

const onEmailFieldBlur = () => {
  const emailField = document.querySelector('[name="Form.EmailAddress"]')
  const firstNameField = document.querySelector('[name="Form.FirstName"]')
  const lastNameField = document.querySelector('[name="Form.LastName"]')

  if (emailField && emailField.value) {
    // Identify log rocket user
    const info = {
      name: `${(firstNameField || {}).value || 'Unknown'} ${(lastNameField || {}).value || 'Unknown'}`,
      email: emailField.value
    }
    LogRocket.identify(id, info)
  }
}


const LogRocketTracking = { initQuoteFormTracking }
export default LogRocketTracking



// WEBPACK FOOTER //
// ./js/self-serve/core/LogRocketTracking.js